export type TierId = 'kitchen-table' | 'moderately-competitive' | 'tournament-contender' | 'pro';

export interface Tier {
  readonly id: TierId;
  readonly label: string;
  readonly description: string;
}

/** Deck tiers in ascending order. Descriptions describe the deck only (design.md Q7). */
export const TIERS: readonly Tier[] = [
  {
    id: 'kitchen-table',
    label: 'Kitchen Table',
    description: 'Casual or precon-level deck, built for fun.',
  },
  {
    id: 'moderately-competitive',
    label: 'Moderately Competitive',
    description: 'Tuned deck with a clear plan.',
  },
  {
    id: 'tournament-contender',
    label: 'Tournament Contender',
    description: 'Optimised deck that could win a local event.',
  },
  {
    id: 'pro',
    label: 'Pro',
    description: 'Top-tier list built to beat the best decks.',
  },
];
